import React from 'react';
import PropTypes from 'prop-types';

import Input from 'dpl/form/components/Input';
import { FORM_FIELD_VARIANT_TYPES } from 'dpl/shared/form/utils/constants';

import QuestionLayout from '../../components/QuestionLayout';

/** @param {any} props */
export default function TextInputQuestion({
  name,
  title = null,
  subtitle = null,
  placeholder = null,
  variant = FORM_FIELD_VARIANT_TYPES.REGULAR,
  type = 'text'
}) {
  return (
    <div className="TextInputQuestion">
      <QuestionLayout title={title} subtitle={subtitle}>
        <Input
          name={name}
          variant={variant}
          placeholder={placeholder}
          type={type}
        />
      </QuestionLayout>
    </div>
  );
}

TextInputQuestion.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(FORM_FIELD_VARIANT_TYPES)),
  type: PropTypes.string
};
